import BadgeDirective from "primevue/badgedirective"
import PrimeVue from "primevue/config"
import ConfirmationService from "primevue/confirmationservice"
import DialogService from "primevue/dialogservice"
import ToastService from "primevue/toastservice"
import TooltipDirective from "primevue/tooltip"
import type { App } from "vue"

export const primevuePlugin = (app: App) => {
  app.use(PrimeVue)
  app.directive("badge", BadgeDirective)
  app.directive("tooltip", TooltipDirective)
  app.use(ToastService)
  app.use(DialogService)
  app.use(ConfirmationService)
}
